import { useEffect, useRef } from 'react'

interface Options {
  containerSelector?: string
  behavior?: ScrollBehavior
  block?: ScrollLogicalPosition
  inline?: ScrollLogicalPosition
}

export function useScrollIntoViewIfNeeded<T extends HTMLElement>(
  active: boolean,
  {
    containerSelector,
    behavior = 'smooth',
    block = 'center',
    inline = 'start'
  }: Options = {}
) {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!active || !el) return

    const container = containerSelector ? el.closest(containerSelector) : null
    const bounds = container
      ? container.getBoundingClientRect()
      : new DOMRect(0, 0, window.innerWidth, window.innerHeight)
    const rect = el.getBoundingClientRect()

    const fullyVisible =
      rect.top >= bounds.top &&
      rect.left >= bounds.left &&
      rect.bottom <= bounds.bottom &&
      rect.right <= bounds.right

    if (!fullyVisible) el.scrollIntoView({ behavior, block, inline })
  }, [active, containerSelector, behavior, block, inline])

  return ref
}
